/**
 * @desc 站点店铺-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlatformSiteShopResponseDto>
>;
export function request(
  params: API.basics.platformSiteShop.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSiteShop/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
